import React, { useState } from "react";
import axios from "axios";
import { RiDeleteBin2Fill } from "react-icons/ri";
import { GrUserAdmin } from "react-icons/gr";
import { toast } from "react-toastify";
import DeletePopUp from "../DeletePopUp/DeletePopUp";
import { MyContextSupply } from "../../../Context";

const UserTable = ({ users, setIsUserDeleted }) => {
  const { token } = MyContextSupply();
  const [isClickedToDelete, setIsClickedToDelete] = useState(false);
  const [userId, setUserId] = useState(null);
  const toastStyle = {
    position: "top-center",
    autoClose: 2000,
  };
  const onClickDelete = (id) => {
    axios
      .delete(
        `https://stechbackend-9r4c.onrender.com/admin/delete/normal/users/${id}`,
        { headers: { Authorization: token }, withCredentials: true }
      )
      .then((res) => {
        if (res.status === 201) {
          toast.success(res.data.message, toastStyle);
          setIsUserDeleted((prev) => {
            return prev + 1;
          });
        }
      })
      .catch((error) => {
        const status = error.response.status;
        const message = error.response.data.message;
        if (status === 404) {
          toast.warn(message, toastStyle);
        } else if (status === 500) {
          toast.warn(message, toastStyle);
        } else {
          toast.warn(message, toastStyle);
        }
      });
  };
  const CantDeleteAdmin = () => {
    toast.warn("Can't delete admin user from here!", toastStyle);
  };
  return (
    <article className="table-article-user">
      <h1>Users Details</h1>
      <table border="1" className="table-desboard-user">
        <thead>
          <tr className="admin-user-tr">
            <td>Created</td>
            <td>User Id</td>
            <td>First Name</td>
            <td>Delete Account</td>
          </tr>
        </thead>
        <tbody>
          {users.length !== 0 &&
            users &&
            users.map((user) => {
              const { _id: id, createdAt, fname, isAdmin } = user;
              const localDate = new Date(createdAt).toLocaleDateString();
              const localTime = new Date(createdAt).toLocaleTimeString();
              return (
                <tr key={id} className="admin-user-tr">
                  <td>{`${localDate}, ${localTime}`}</td>
                  <td>{id}</td>
                  <td>{fname}</td>
                  <td className={`${isAdmin && "unselectable"}`}>
                    {isAdmin ? (
                      <GrUserAdmin onClick={CantDeleteAdmin} />
                    ) : (
                      <RiDeleteBin2Fill
                        onClick={() => {
                          setIsClickedToDelete(true);
                          setUserId(id);
                        }}
                        className="delete-btn-admin-product-others"
                      />
                    )}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
      <DeletePopUp isClickedToDelete={isClickedToDelete} setIsClickedToDelete={setIsClickedToDelete} onClickDelete={onClickDelete} id={userId} title="user" />
    </article>
  );
};

export default UserTable;
